import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import { logMixPanelEvent } from '../../services/tracking/mixPanel';
import { useParams, useNavigate } from 'react-router-dom';
import { action } from '../../services/api/action/action';

// i need this variable to call the API action just one time
let update = true;

const HelpPage = () => {
  const navigate = useNavigate();
  const { hash } = useParams();

  useEffect(() => {
    if(update){
      update = false;
      logMixPanelEvent('mail_click', {hash});

      action(hash || '')
      .then((response) => {
        // setPopupCta({
        //   actionLink: hash,
        //   actionType: response.data.actionType,
        //   popupMessage: response.data.message,
        //   showPopup: response.data.showPopup,
        //   ctaText: response.data.ctaText,
        // });
        
        // redirect
        const redirect = `${response.redirect}`;
        navigate(redirect);
      })
    }
  }, [hash]);

  return (
    <Box>
      <Box px={4} pt={4} pb={2} display="flex" alignItems="center" gap={1}>
        <WorkHistoryIcon fontSize="large" />
        <Typography variant="h4" fontWeight="bold" p={0}>
          Updating...
        </Typography>
      </Box>
    </Box>
  );
};

export default HelpPage;
